function unwrapReportRoot(payload) {
  if (!payload || typeof payload !== 'object') return {};
  let body = payload.data !== undefined ? payload.data : payload;
  if (body && typeof body === 'object' && body.data && typeof body.data === 'object') {
    const inner = body.data;
    if (
      inner.orders != null ||
      inner.productsPeek != null ||
      inner.summary != null ||
      inner.breakdown != null ||
      inner.extras != null ||
      inner.variations != null
    ) {
      return inner;
    }
  }
  return body && typeof body === 'object' ? body : {};
}

/**
 * Normalizes GET dashboard/admin/reports/overview (and similar) payloads.
 */
export function normalizeReportsOverviewPayload(payload) {
  const root = unwrapReportRoot(payload);
  const orders = root.orders || {};
  const productsPeek = root.productsPeek || {};

  return {
    ordersSummary: orders.summary && typeof orders.summary === 'object' ? orders.summary : {},
    ordersSeries: Array.isArray(orders.series) ? orders.series : [],
    topLines: Array.isArray(productsPeek.topLines) ? productsPeek.topLines : [],
    categoryBreakdown: Array.isArray(productsPeek.categoryBreakdown)
      ? productsPeek.categoryBreakdown
      : [],
    snapshotNote:
      root.snapshotNote ||
      productsPeek.snapshotNote ||
      root.snapshot_note ||
      '',
    carts: root.carts,
  };
}

export function normalizeReportsRevenuePayload(payload) {
  const root = unwrapReportRoot(payload);
  return {
    summary: root.summary && typeof root.summary === 'object' ? root.summary : {},
    series: Array.isArray(root.series) ? root.series : [],
  };
}

export function normalizeReportsCategoriesPayload(payload) {
  const root = unwrapReportRoot(payload);
  const breakdown = root.breakdown;
  return {
    breakdown: Array.isArray(breakdown) ? breakdown : Array.isArray(root.data) ? root.data : [],
    series: Array.isArray(root.series) ? root.series : [],
  };
}

export function normalizePaginationBlock(block) {
  const p = block && typeof block === 'object' ? block : {};
  return {
    total: p.total ?? p.totalCount ?? 0,
    current: p.page ?? p.current_page ?? p.currentPage ?? 1,
    pageSize: p.perPage ?? p.per_page ?? 10,
  };
}

export function normalizeReportsExtrasVariationsPayload(payload) {
  const root = unwrapReportRoot(payload);
  const extras = root.extras || {};
  const variations = root.variations || {};

  return {
    extrasData: Array.isArray(extras.data) ? extras.data : [],
    extrasPagination: normalizePaginationBlock(extras.pagination || extras.meta),
    variationsData: Array.isArray(variations.data) ? variations.data : [],
    variationsPagination: normalizePaginationBlock(variations.pagination || variations.meta),
    snapshotNote: root.snapshotNote || root.snapshot_note || '',
  };
}
